import axiosClient from "./axiosClient";

export const listarUsuarios = () => axiosClient.get("/mantenimiento/usuarios").then((r) => r.data);
export const upsertUsuario = (data) => axiosClient.post("/mantenimiento/usuarios", data).then((r) => r.data);
export const eliminarUsuario = (id) => axiosClient.delete(`/mantenimiento/usuarios/${id}`);
